// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__MleLe","open":"sidebar_open__cTMid","close":"sidebar_close__I+jBB"};